import { Divider, Grid, Typography } from "@mui/material";
import { ActionButton } from "../../../../components/Button";
import Dialog from "../../../../components/Dialog";
import { IRemoveDialogProps } from "../../../../components/Dialog";
import { useLanguageContext } from "../../../../contexts/LanguageContext";
import DefaultConstants from "../../../../data/Constants";
import FormHelper from "../../../../helpers/FormHelper";
import { useCallback, useMemo } from 'react';
import { IRoomBlocking } from "../../../../interfaces/IPartnerPms";
import PartnerPmsService from "../../../../services/PartnerPmsService";
import DateTimeHelper from "../../../../helpers/DateTimeHelper";


const RemoveDialog: React.FunctionComponent<IRemoveDialogProps<IRoomBlocking>> = ({
    open,
    handleClose,
    data,
    handleListRefresh = () => {}
}) => {
    const { translate } = useLanguageContext();


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        let formData = FormHelper.Create(event);
        formData = FormHelper.Add(formData, 'id', data?.id);

        PartnerPmsService.RemoveRoomBlocking(formData).then(() => {
            handleClose();
            handleListRefresh();
        });

        // eslint-disable-next-line
    }, [data]);
    

    const dialogActions = useMemo(() => {
        return [
            <ActionButton action="no" onClick={handleClose} />, 
            <ActionButton action="yes" type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);


    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('remove')}
            dialogActions={dialogActions}
            fullWidth={true}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween'
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <Typography variant='body1'>
                        {translate('_removeDialogDescription')}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <Divider />
                </Grid>

                <Grid item xs={12}>
                    <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                        <Grid item xs={6}>
                            <Typography variant='caption' className='fontsize-10 text-color-2'>
                                {translate('room')}
                            </Typography>

                            <Typography variant='body2'>
                                {data?.roomDescription ?? '-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography variant='caption' className='fontsize-10 text-color-2'>
                                {translate('date')}
                            </Typography>

                            <Typography variant='body2'>
                                {data?.date ? DateTimeHelper.Format(data.date, 'DD/MM/YYYY') : '-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='caption' className='fontsize-10 text-color-2'>
                                {translate('blockingType')}
                            </Typography>

                            <Typography variant='body2'>
                                {data?.typeDescription ?? '-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant='caption' className='fontsize-10 text-color-2'>
                                {translate('description')}
                            </Typography>

                            <Typography variant='body2'>
                                {data?.description ?? '-'}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default RemoveDialog;